import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.complexion;

const getComplexion = createSelector(getData, complexion => values(complexion));

export default getComplexion;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getComplexion.js